// https://github.com/axios/axios#axios-api
import axios from 'axios';
import cookie from 'cookie_js';
import { stringIsNullOrUndefinedOrBlank } from './siteFunctions';
import appConfig from '../config';

const instance = axios.create({
	// baseURL: 'https://2fe4w5vk19.execute-api.us-west-2.amazonaws.com/dev/', // dev
	// baseURL: 'https://lhkt5xlct2.execute-api.us-east-1.amazonaws.com/api/', // prod
	// baseURL: 'https://localhost:44320/', // local
	baseURL: appConfig.apiUrl,
	headers: {
		'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0,private'
	}
});

instance.interceptors.request.use(
	async config => {
		const jwt = cookie('simplicity-client-portal-jwt');

		config.headers = {
			// 'x-api-key': 'xKXRi0RLBy3J0vf93ENcRyEVOQ3yi2g7lHsEMwm2', // dev
			// 'x-api-key': '2wxj6ex1Hk3osLJvZ2zZU3QiJ0ZgOTso4cUFc8tb', // prod
			'x-api-key': '2wxj6ex1Hk3osLJvZ2zZU3QiJ0ZgOTso4cUFc8tb', //process.env.REACT_APP_API_KEY,
			'Authorization': stringIsNullOrUndefinedOrBlank(jwt) ? undefined : `Bearer ${jwt}`
			//'Host': '2fe4w5vk19.execute-api.us-west-2.amazonaws.com' //'lhkt5xlct2.execute-api.us-east-1.amazonaws.com'
		};

		// TODO: configure how to get the JWT for auth calls
		// const token = '';
		// if (token) {
		// 	config.headers = {
		// 		'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0,private',
		// 		'Authorization': `Bearer ${token}`
		// 	};
		// }

		return config;
	},
	error => Promise.reject(error)
);

instance.interceptors.response.use(
	async response => {
		// Note: here you can do things with successful request before
		// they get returned to who called them

		return response;
	},
	async error => {
		// Note: here you can do things with error responses before
		// they get returned to who called them e.g. show an alertbox
		// with the error message that gets returned

		return Promise.reject(error);
	}
);

export default instance;